import { Box, Image, Text, Tooltip } from "@chakra-ui/react";
import Rank from "./Rank";

export default function IndividualLeadershipBoardCard({ employee, id }) {
    return (
        <Box
            d='flex'
            w='100%'
            alignItems='center'
        >
            <Rank id={id} key={id} />
            <Box
                d='flex'
                justifyContent='space-between'
                alignItems='center'
                borderBottom='1px solid rgba(0, 0, 0, 0.05)'
                w='100%'
                py='0.5rem'
                pr='0.5rem'
            >
                <Image
                    src={employee.avatar ? employee.avatar : './images/unavailable-image.jpg'}
                    // fallbackSrc='https://source.unsplash.com/random/800x600'
                    width='35px'
                    height='35px'
                    borderRadius='50%'
                    objectFit='cover'
                />

                <Tooltip
                    label={`${employee.first_name} ${employee.last_name}`}
                    fontSize='16px'
                    style={{ fontFamily: 'Mulish, sans-serif' }}
                    fontWeight='400'
                    color='#ffffff'
                    bg='#333333'
                    hasArrow
                >
                    <Text
                        w='60%'
                        textAlign='start'
                        whiteSpace='nowrap'
                        overflow='hidden'
                        textOverflow='ellipsis'
                    >
                        {employee.first_name} {employee.last_name}
                    </Text>
                </Tooltip>
                <Text
                    w='15%'
                >
                    {employee.scores_count}
                </Text>
            </Box>

        </Box>
    )
}